export const costs = [
  'Information scattered across manuals, forums and videos',
  'No clear picture of how power and cooling work together',
  'Uncertainty in technical interviews',
  'Slower career growth in one of the fastest-growing industries',
];
